import { initialFormValues as akaAdviceFormValues } from "Components/Features/CheckPrice/Products/Advice/ProductPriceAka";
import { AkaAdvicePriceFormValues } from "Components/Features/CheckPrice/Products/Advice/ProductPriceAka/AkaAdviceCards/interfaces";
import { CollectiveAdvice } from "Store/akaAdvice/interfaces/CollectiveAdvice";
import { mapToCrtiticalIllnessFormValues } from "./mapToCriticalIllnessFormValues";
import { mapToDeathFormValues } from "./mapToDeathFormValues";
import { mapToDisabilityFormValues } from "./mapToDisabilityFormValues";
import { mapToIndividualCriticalIllnessFormValues } from "./mapToIndividualCriticalIllnessFormValues";
import { mapToIndividualDeathFormValues } from "./mapToIndividualDeathFormValues";
import { mapToIndividualDisabilityFormValues } from "./mapToIndividualDisabilityFormValues";

export const mapToFormValues = (
  isCollectiveAdvice: boolean,
  isAdvisor: boolean,
  adviceResponse: CollectiveAdvice,
  akaAdvicePriceFormValues: AkaAdvicePriceFormValues | undefined,
): AkaAdvicePriceFormValues => {
  const formValues = isCollectiveAdvice
    ? mapToCollectiveFormValues(isAdvisor, adviceResponse)
    : mapToIndividualFormValues(isAdvisor, adviceResponse);
  return {
    ...akaAdviceFormValues,
    ...formValues,
    deathAdviceComment: akaAdvicePriceFormValues?.deathAdviceComment,
    disabilityAdviceComment: akaAdvicePriceFormValues?.disabilityAdviceComment,
    criticalIllnessAdviceComment:
      akaAdvicePriceFormValues?.criticalIllnessAdviceComment,
  };
};

const mapToCollectiveFormValues = (
  isAdvisor: boolean,
  adviceResponse: CollectiveAdvice,
): Partial<AkaAdvicePriceFormValues> => {
  const { LIFE, DISABILITY, CRITICAL_ILLNESS } = adviceResponse.needs;
  return {
    ...mapToDeathFormValues(isAdvisor, LIFE),
    ...mapToDisabilityFormValues(isAdvisor, DISABILITY),
    ...mapToCrtiticalIllnessFormValues(isAdvisor, CRITICAL_ILLNESS),
  };
};

const mapToIndividualFormValues = (
  isAdvisor: boolean,
  adviceResponse: CollectiveAdvice,
): Partial<AkaAdvicePriceFormValues> => {
  const { LIFE, DISABILITY, CRITICAL_ILLNESS } = adviceResponse.needs;
  return {
    ...mapToIndividualDeathFormValues(isAdvisor, LIFE),
    ...mapToIndividualDisabilityFormValues(isAdvisor, DISABILITY),
    ...mapToIndividualCriticalIllnessFormValues(isAdvisor, CRITICAL_ILLNESS),
  };
};
